import md5 from 'js-md5';
import { apiGetByRefresh } from './service';
import { myGames, myGamesJson } from '../components/ElectronLayout/ElectronHead/server';
import { userInfoProps } from '@/views/user/personal/typings';
import store from '@/store/index';
import { setUserInfo } from '@/store/module/user';
import { setRecentlyPlayGame } from '@/store/module/recentPlayGame';
import { setBaseInfoData } from '@/store/baseData';
import { getToken } from './cookie';
import { WordFilter } from './WordFilter';
import AdminConfig from '../config';
import { setLocalStorage, getLocalStorage, removeLocalStorage } from './localStorage';
import { defaults, updateLayoutSettings } from '@/store/module/setting';
import { listJson, getTagVersionList, versionTagJson } from '@/store/baseData/service';
// import { createBrowserHistory } from 'history';
import { setBaseTipInfo } from '@/store/baseData/baseTip';
import { EnterGameData } from '@/views/system/gameDetail/server';
import utils from '@/views/login/utils';
import { getAllLabel } from '@/views/system/rankings/server';
import { localKeyInfo } from '@/views/Voice/store/config';
import {
  apiGetQuerySvipUserRightValue,
  apiGetSvipUserInfo,
  querySvipUserRightValueProps,
  SvipUserInfoProps
} from '@/views/user/member/service';
import { updateSvipUserInfos } from '@/store/userMember/svipUserInfo';
import { updateCustomer } from '@/store/userMember/customer';
import sdk from '@/utils/Buryingpoint';
import LocalStore from './store';
import httpApi from '@/apis/httpApi';
import { loginCollect } from '@/config/collect/loginCollect';
import { postCollect } from '@/views/community/homePage/service';
import { setRealnameInfo } from '@/store/baseData/realnameStatus';
import StorageFn from '@/utils/electronStorage';
import { apiShopCartConf, ShopCartConfProps } from '@/views/system/transaction/myBox/purchase/server';
import { updateShopCartConfs } from '@/store/module/shopCartConf';
import { GetListProps } from '@/views/user/wallet/service';

import { ignoreLive } from '@/config/versionPanel';
import moment from 'moment';
import { sdkBoxCollect } from '@/config/collect/shoppingCollect';
import liveFn from '@/views/NewLive/liveFn';

const processName2Type: any = {
  'cq2.exe': 1,
  'CocosPc_release.exe': 2,
  'woool.dat|GameClient.exe': 2,
  'rjengineb.exe': 3,
  'hy9963D_Client.exe': 4,
  'BoxLauncher.exe': 5
};

// 生成随机字符串
function generateRandomString(length: number = 32): string {
  const chars = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
  ];
  let result = '';
  for (let i = 0; i < length; i++) {
    const id = Math.ceil(Math.random() * 35);
    result += chars[id];
  }
  return result;
}

const electronModalProps = (params: number, titleName?: string) => {
  (window as any).raw.createWindow(
    {
      url: `${window.location.origin}/competition/live?LiveBroadcast=${params}&titleName=${titleName}`,
      width: 1000,
      height: 745,
      minW: 1000,
      minH: 745
    },
    (e: any) => {
      if (e.status === 'resolve') {
        setLocalStorage(AdminConfig.strWinId, e.data.winId);
      }
    }
  );
};

const playBackModalProps = (val: string, titleName?: string) => {
  (window as any).raw.createWindow(
    {
      url: `${window.location.origin}/competition/live?VideoUrl=${val}&titleName=${titleName}`,
      width: 1000,
      height: 666,
      minW: 1000,
      minH: 666
    },
    (e: any) => {
      if (e.status === 'resolve') {
        setLocalStorage(AdminConfig.strWinId, e.data.winId);
      }
    }
  );
};

// 统一编码 GET 查询参数中的中文值，避免中文字符导致签名不一致
function encodeUrlQueryForSign(rawUrl = '') {
  if (!rawUrl || typeof rawUrl !== 'string') return rawUrl;

  const queryIndex = rawUrl.indexOf('?');
  if (queryIndex < 0) return rawUrl;

  const path = rawUrl.substring(0, queryIndex);
  const query = rawUrl.substring(queryIndex + 1);
  if (!query) return rawUrl;

  const safeDecode = (text: string) => {
    try {
      return decodeURIComponent((text || '').replace(/\+/g, '%20'));
    } catch (e) {
      return text || '';
    }
  };
  const hasChinese = (text: string) => /[\u4e00-\u9fa5]/.test(text);

  const encodedQuery = query
    .split('&')
    .filter(pair => pair !== '')
    .map(pair => {
      const [rawKey, ...rest] = pair.split('=');
      const rawValue = rest.join('=');
      const decodedValue = safeDecode(rawValue);
      const value = hasChinese(decodedValue) ? encodeURIComponent(decodedValue) : rawValue;
      return `${rawKey}=${value}`;
    })
    .join('&');

  return encodedQuery ? `${path}?${encodedQuery}` : path;
}
/**
 * 比较两个版本号
 * @param {string} v1 - 版本号1 (例如 "1.2.0")
 * @param {string} v2 - 版本号2 (例如 "1.10.0")
 * @returns {number} 1 (v1 > v2), -1 (v1 < v2), 0 (v1 === v2)
 */
const compareVersion = (v1: string, v2 = '5.0.1') => {
  const v1Num = v1.replace(/[^0-9]/g, '').slice(0, 3);
  const v2Num = v2.replace(/[^0-9]/g, '').slice(0, 3);
  if (v1Num > v2Num) return 1;
  if (v1Num < v2Num) return -1;
  return 0;
};

const ProjFn = {
  compareVersion,
  generateRandomString,
  // 接口验签v2
  toSignV2: async (requestBody: any, signObj?: any) => {
    const appv = localStorage.getItem('appv')?.replace(/&.+/, '') || '';
    const status = ProjFn.compareVersion(appv, '5.0.1');
    const hasBoxAuth = status >= 0;
    if (hasBoxAuth && (window as any)?.MIS?.E2SignCer) {
      const normalizedMethod = String(signObj?.method || '').toUpperCase();
      const normalizedSignObj = {
        ...(signObj || {}),
        method: normalizedMethod,
        url: normalizedMethod === 'GET' ? encodeUrlQueryForSign(signObj?.url || '') : signObj?.url
      };

      // 这里保留对象处理逻辑仅作为兼容性保护
      let requestBodyStr = '';
      if (typeof requestBody === 'string') {
        requestBodyStr = requestBody;
      } else if (requestBody !== undefined && requestBody !== null) {
        // 兼容性处理：如果直接传入对象，转为 JSON 字符串
        // 注意：正常情况下应该由 getRequestBody 处理，这里不应该执行
        try {
          requestBodyStr = JSON.stringify(requestBody);
        } catch (e) {
          requestBodyStr = '';
        }
      }
      const isGetMethod = normalizedMethod === 'GET';
      const data = isGetMethod ? {} : requestBodyStr || {};
      const param = '';
      const sign = await (window as any).MIS?.E2SignCer({ data, param, signObj: normalizedSignObj });
      return sign;
    }
    return '';
  }, // 接口验签
  toSign: (obj: any, signObj?: any, isWebsocket?: string) => {
    // 按照升序排序obj属性
    if ((window as any)?.MIS?.E2Sign && !isWebsocket) {
      return (window as any).MIS.E2Sign({ obj, signObj, md5 });
    }
    const sortObj = ProjFn.returnResetInfo(JSON.parse(JSON.stringify(obj)));
    let resNum = generateRandomString(32);
    const newkey = Object.keys(sortObj).sort();
    const newObj: any = {};
    newkey.forEach((item, i) => {
      // 遍历newkey数组
      newObj[newkey[i]] = sortObj[newkey[i]];
      // 向新创建的对象中按照排好的顺序依次增加键值对
    });
    const keyArr = [];
    for (const y in newObj) {
      if (true) {
        const x = newObj[y];
        keyArr.push(x);
        if (newObj[y] === undefined || newObj[y] == null) {
          newObj[y] = '';
        }
      }
    }
    newObj.rqtime = Date.parse(String(new Date()));
    newObj.rqrandom = resNum;
    if (signObj) {
      keyArr.push(newObj.rqtime);
      keyArr.push(newObj.rqrandom);
      keyArr.push(httpApi.signkey);
    } else {
      keyArr.push(AdminConfig.OLDSIGN_KEY);
      keyArr.push(newObj.rqtime);
      keyArr.push(newObj.rqrandom);
    }
    let sginStr = '';
    keyArr.forEach(item => {
      if (typeof item == 'object') {
        return JSON.stringify(item);
      }
    });
    // 将字符串按验签规则拼接
    for (const y in keyArr) {
      if (true) {
        if (typeof keyArr[y] == 'object' && keyArr[y] != null) {
          sginStr = sginStr + JSON.stringify(keyArr[y]);
        } else if (keyArr[y] === undefined || keyArr[y] == null) {
          keyArr[y] = '';
          const sginArr = sginStr;
          sginStr = sginArr;
        } else {
          sginStr = sginStr + keyArr[y];
        }
      }
    }
    if (signObj) {
      const value = `appv=${signObj.appv}&device=${signObj.device}&deviceId=${
        signObj.deviceId
      }&box-agent=${ProjFn.headerBoxAgent(signObj)}&${sginStr}`;
      newObj.sign = md5(value);
    } else {
      newObj.sign = md5(sginStr);
    }
    return newObj;
  },
  headerBoxAgent(obj: any) {
    const param = Object.keys(obj);
    const data = Object.values(obj);
    let sign = '';
    param.forEach((item, index) => {
      const val = data[index] === undefined ? '' : data[index];
      sign += `${item}:${val};`;
    });
    return sign;
  },
  returnResetInfo(obj: any) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    delete obj.rqrandom;
    delete obj.rqtime;
    delete obj.sign;
    return obj;
  },
  getBoxVersion() {
    const strVersion: any = localStorage.getItem('appv')?.replace(/&.+/, '');
    let numVersion = strVersion.replace(/[^0-9]/g, '');
    const mainVersion = numVersion.slice(0, 3);
    return Number(mainVersion);
  },
  toOpenTimes: (time: number) => {
    if (!time) {
      return '';
    } else {
      const date = new Date(time * 1000);
      const dateNumFun = (num: number) => (num < 10 ? `0${num}` : num);
      const [h, m] = [dateNumFun(date.getHours()), dateNumFun(date.getMinutes())];
      return `${h}:${m}`;
    }
  },
  // 游戏热度
  hotEllipsis: (item: number) => {
    const value = item + '';
    if (!value) return '';
    if (value.length === 5) {
      return value.slice(0, 1) + 'w+';
    }
    if (value.length === 6) {
      return value.slice(0, 2) + 'w+';
    }
    if (value.length >= 7) {
      return value.slice(0, 0) + '99w+';
    }
    return value;
  },
  // 类型切分
  toTags: (list: string): any => {
    if (list === '') {
      return [];
    }
    if (Array.isArray(list)) {
      return list;
    }
    const arr = list.split('|');
    return arr;
  },
  // 获取用户信息
  getByRefresh: (val?: boolean, cb?: Function) => {
    apiGetByRefresh().then(({ data }: { data: userInfoProps }) => {
      store.dispatch(
        setUserInfo({
          token: getToken(),
          userinfo: data.userinfo
        })
      );
      if (val) {
        const TRANSATION_KEY = 'TRANSATION_MYBOX_COM_STATE';
        let transationObj = getLocalStorage(TRANSATION_KEY) ? JSON.parse(getLocalStorage(TRANSATION_KEY)) : '';
        if (transationObj) {
          transationObj.chargeToken = '';
          setLocalStorage(TRANSATION_KEY, JSON.stringify(transationObj));
        }
        cb && cb();
        setTimeout(() => {
          // before login upload event
          sdk.Burying({
            uid: String(data.userinfo.id),
            eventname: 'buttonClick',
            eventtype: 'track',
            properities: {
              buttonName: 'hezidenglu'
            }
          });
          utils.openMain();
        }, 300);
      }
    });
    apiGetSvipUserInfo().then(({ data }: { data: SvipUserInfoProps }) => {
      store.dispatch(updateSvipUserInfos(data));
    });
    apiGetQuerySvipUserRightValue({ rightCode: 'RC_SERV' }).then(({ data }: { data: querySvipUserRightValueProps }) => {
      store.dispatch(updateCustomer(data));
    });
  },
  // 获取最近在玩
  getRecentlyPlayGame: async () => {
    const str = localStorage.getItem('BASE_TRUMPET_INFO');
    const obj = str ? JSON.parse(str) : {};
    const info: any = {
      sub_uid: ''
    };
    if (obj && obj.uid && obj.selectUid && obj.uid !== obj.selectUid) {
      info.sub_uid = obj.selectUid;
    }
    if (!info.sub_uid) delete info.sub_uid;
    myGames(info).then(({ data }: { data: myGamesJson }) => {
      store.dispatch(
        setRecentlyPlayGame({
          gameList: data.game_list
        })
      );
    });
  },
  // 小号参数判断
  getIsSubAccount: (info: EnterGameData) => {
    const str = localStorage.getItem('BASE_TRUMPET_INFO');
    const obj = str ? JSON.parse(str) : {};
    if (obj && obj.uid && obj.selectUid && obj.selectAccount && obj.uid !== obj.selectUid) {
      info.sub_uid = obj.selectUid;
    }
    return info;
  },
  // 获取平台and类型and特色
  getBaseTagVersion: () => {
    getTagVersionList().then(({ data }: { data: versionTagJson }) => {
      const str = localStorage.getItem('BASE_INFO_DATA');
      const obj = str ? JSON.parse(str) : {};
      const tagLists =
        data.tagList &&
        data.tagList.filter((item: listJson) => {
          return item.tag_name && item.tag_name !== '必玩好服';
        });
      store.dispatch(
        setBaseInfoData({
          ...obj,
          versionList: data.versionList,
          tagList: tagLists,
          tagLists: data.tagList
        })
      );
    });
  },
  // 获取排行游戏标签
  getRankListTag: async () => {
    const { data } = await getAllLabel({
      gameType: Number(localStorage.getItem('NAV_TABBTN_ID'))
    });
    // TODO 分组
    interface sdobj {
      title: string;
      groupId?: number;
      child: listJson[];
    }
    let sectionalSort: string[] = [];
    let sectionalization: any = {};
    let sectionalData: sdobj[] = [];
    let tagsMap: { [key: string]: any } = {};
    for (let i = 0, len = data.length; i < len; i += 1) {
      tagsMap[data[i].labelId] = data[i].labelName;
      if (sectionalization[data[i].labelTitle]) {
        sectionalization[data[i].labelTitle].push(data[i]);
      } else {
        sectionalization[data[i].labelTitle] = [data[i]];
      }
      sectionalSort.push(data[i].groupName);
    }
    sectionalSort = sectionalSort.filter((value, index) => sectionalSort.indexOf(value) === index);
    for (let i = 0, len = sectionalSort.length; i < len; i += 1) {
      sectionalData.push({
        title: sectionalSort[i],
        groupId: sectionalization[sectionalSort[i]][0].groupId,
        child: sectionalization[sectionalSort[i]]
      });
    }
    setTimeout(() => {
      const str = localStorage.getItem('BASE_INFO_DATA');
      const obj = str ? JSON.parse(str) : {};
      store.dispatch(
        setBaseInfoData({
          ...obj,
          rankTagList: sectionalData,
          rankTagRawList: data,
          tagNameMap: tagsMap
        })
      );
    }, 500);
  },
  // 直播热度
  monryEllipsis: (item: any) => {
    let value = item;
    if (typeof item === 'string') {
      value = Number(value);
    }
    let unit: string = '';
    const k: number = 9999.9;
    const sizes: string[] = ['', '万', '亿', '万亿'];
    let i: number;
    if (value > k) {
      i = Math.floor(Math.log(value) / Math.log(k));
      value = parseFloat(String(value / Math.pow(k, i))).toFixed(1);
      unit = sizes[i];
    }
    return value + unit;
  },
  // 获取富文本内容里的纯文本
  getSimpleText: (html: string) => {
    const re1 = new RegExp('<.+?>', 'g'); // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
    const msg = html.replace(re1, ''); // 执行替换成空字符
    return msg;
  },
  // 获取富文本内容里的img,src
  getContentImg: (content: any, type?: number) => {
    let imgArr = [];
    if (type === 1) {
      const reg = new RegExp(`<img src="//land-dev.996box.com/img/link_icon.png">"`, 'g');
      const reg2 = new RegExp(`//land-dev.996box.com/img/link_icon.png`, 'g');
      content = content.replace(reg, '');
      content = content.replace(reg2, '');
    }
    if (content.match(/<img\b.*?(?:>|\/>)/g)) {
      try {
        imgArr = content
          .match(/<img\b.*?(?:>|\/>)/g)
          .map((item: any) => JSON.parse(item.match(/\bsrc\b\s*=\s*['"]?([^'"]*)['"]?/g)[0].replace('src=', '')));
      } catch (error) {}
    }
    if (imgArr.length && type === 1) {
      imgArr = imgArr.filter((item: any) => {
        const patt = /^(f|ht)tps?:\/\//i;
        return patt.test(item) === true;
      });
    }
    return imgArr;
  },
  // 删除富文本中的图片
  delContentImg: (content: any) => {
    content = content.replace(/<img .*?>/g, '');
    return content;
  },
  // 获取富文本内容里的video,src
  getContentVideo: (content: any) => {
    let videoArr = [];
    if (content.match(/<video\b.*?(?:>|\/>)/g)) {
      try {
        videoArr = content
          .match(/<video\b.*?(?:>|\/>)/g)
          .map((item: any) => JSON.parse(item.match(/\bsrc\b\s*=\s*['"]?([^'"]*)['"]?/g)[0].replace('src=', '')));
      } catch (error) {}
    }
    return videoArr;
  },
  // 获取时分
  getTimeDivision: () => {
    const date = new Date();
    const dateNumFun = (num: any) => (num < 10 ? `0${num}` : num);
    const [h, m] = [dateNumFun(date.getHours()), dateNumFun(date.getMinutes())];
    const time = `${h}:${m}`;
    return time;
  },
  // 最新回复时间
  getDateDiff: (time: number) => {
    if (!time) {
      return '';
    } else {
      const dateNumFun = new Date(time * 1000);
      const timeNow = parseInt(String(new Date().getTime() / 1000), 0);
      let [M, D, h, m, s]: any = [
        dateNumFun.getMonth() + 1,
        dateNumFun.getDate(),
        dateNumFun.getHours(),
        dateNumFun.getMinutes(),
        dateNumFun.getSeconds()
      ];
      if (M < 10) {
        M = '0' + M;
      }
      if (D < 10) {
        D = '0' + D;
      }
      if (h < 10) {
        h = '0' + h;
      }
      if (m < 10) {
        m = '0' + m;
      }
      if (s < 10) {
        s = '0' + s;
      }
      const d = timeNow - time;
      const [ddays, dhours, dminutes, dseconds]: any = [
        parseInt(String(d / 86400), 0),
        parseInt(String(d / 3600), 0),
        parseInt(String(d / 60), 0),
        parseInt(String(d), 0)
      ];
      if (ddays > 0 && ddays < 30) {
        return ddays + '天前';
      } else if (ddays <= 0 && dhours > 0) {
        return dhours + '小时前';
      } else if (dhours <= 0 && dminutes > 0) {
        return dminutes + '分钟前';
      } else if (dseconds < 60) {
        if (dseconds <= 0) {
          return '刚刚';
        } else {
          return dseconds + '秒前';
        }
      } else if (ddays >= 30 && ddays < 60) {
        return '1月前';
      } else if (ddays >= 60 && ddays < 90) {
        return '2月前';
      } else if (ddays >= 90) {
        return '3月前';
      }
    }
  },
  // 屏蔽词库
  filter: (val: string) => {
    return WordFilter.instance().replace(val);
  },
  // 转换成时间
  toDateSymbol: (time?: number) => {
    if (!time) {
      return '';
    } else {
      const date = new Date(time * 1000);
      const dateNumFun = (num: number) => (num < 10 ? `0${num}` : num);
      const [Y, M, D, h, m] = [
        date.getFullYear(),
        dateNumFun(date.getMonth() + 1),
        dateNumFun(date.getDate()),
        dateNumFun(date.getHours()),
        dateNumFun(date.getMinutes()),
        dateNumFun(date.getSeconds())
      ];
      return `${Y}-${M}-${D} ${h}:${m}`;
    }
  },
  // 转换成时间--s
  toDateSecond: (time?: number) => {
    if (!time) {
      return '';
    } else {
      const date = new Date(time * 1000);
      const dateNumFun = (num: number) => (num < 10 ? `0${num}` : num);
      const [Y, M, D, h, m, s] = [
        date.getFullYear(),
        dateNumFun(date.getMonth() + 1),
        dateNumFun(date.getDate()),
        dateNumFun(date.getHours()),
        dateNumFun(date.getMinutes()),
        dateNumFun(date.getSeconds())
      ];
      return `${Y}-${M}-${D} ${h}:${m}:${s}`;
    }
  },
  // 获取年月日
  toCompareTimes: (time: number) => {
    if (!time) {
      return '';
    } else {
      const date = new Date(time * 1000);
      const dateNumFun = (num: number) => (num < 10 ? `0${num}` : num);
      const [Y, M, D] = [date.getFullYear(), dateNumFun(date.getMonth() + 1), dateNumFun(date.getDate())];
      return `${Y}-${M}-${D}`;
    }
  },
  // 转换成时间
  toTimess: (time: number) => {
    if (!time) {
      return '';
    } else {
      const date = new Date(time * 1000);
      const dateNumFun = (num: number) => (num < 10 ? `0${num}` : num);
      const [Y, M, D, h, m] = [
        date.getFullYear(),
        dateNumFun(date.getMonth() + 1),
        dateNumFun(date.getDate()),
        dateNumFun(date.getHours()),
        dateNumFun(date.getMinutes())
      ];
      return `${Y}-${M}-${D} ${h}:${m}`;
    }
  },
  // 手机号码机密显示
  phoneEncrypt: (phone: any) => {
    return phone.replace(/(\w{2})(\w{7})(.*)/, '$1*******$3');
  },
  // 保留两位小数
  byHundred: (num?: number) => {
    if (!num) return 0;
    return parseFloat((num / 100).toFixed(2));
  },
  // 金额三位间隔
  interval: (key: string) => {
    key += '';
    const x = key.split('.');
    let x1 = x[0];
    const x2 = x.length > 1 ? '.' + x[1] : '';
    const reg = /(\d+)(\d{3})/;
    while (reg.test(x1)) {
      x1 = x1.replace(reg, `$1,$2`);
    }
    return x1 + x2;
  },
  // 详情页开服日期
  toDateDetailOpenServe: (time: number) => {
    if (!time) {
      return '';
    } else {
      const date = new Date(time * 1000);
      const dateNumFun = (num: number) => (num < 10 ? `0${num}` : num);
      const [M, D] = [dateNumFun(date.getMonth() + 1), dateNumFun(date.getDate())];
      return `${M}-${D}`;
    }
  },
  // 游戏热度数量处理
  hotGetNumber: (num: any) => {
    let hotNum = num ? num : 0;
    if ((num + '').length >= 5) {
      num = num / 10000;
      hotNum = parseInt(String(num * 10), 0) / 10 + 'w';
    }
    return hotNum;
  },
  // 匹配字符出现次数
  getCharCount: (str: string, char: string | RegExp) => {
    const regex = new RegExp(char, 'g');
    const result = str.match(regex);
    const count = !result ? 0 : result.length;
    return count;
  },
  electronModal: (params: number, titleName?: string) => {
    if (!getToken()) {
      store.dispatch(
        updateLayoutSettings({
          ...defaults,
          loginEvoke: true
        })
      );
      return;
    }
    if ((window as any).raw) {
      if (getLocalStorage(AdminConfig.strWinId)) {
        (window as any).raw.reloadWindow(
          {
            url: `${window.location.origin}/competition/live?LiveBroadcast=${params}&titleName=${titleName}`,
            winId: getLocalStorage(AdminConfig.strWinId)
          },
          (e: any) => {
            if (e.status === 'reject') {
              electronModalProps(params, titleName);
            }
          }
        );
        return;
      }
      electronModalProps(params, titleName);
    }
  },
  electronModalProps: (params: number, titleName?: string) => {
    (window as any).raw.createWindow(
      {
        url: `${window.location.origin}/competition/live?LiveBroadcast=${params}&titleName=${titleName}`,
        width: 1000,
        height: 745,
        minW: 1000,
        minH: 745
      },
      (e: any) => {
        if (e.status === 'resolve') {
          setLocalStorage(AdminConfig.strWinId, e.data.winId);
        }
      }
    );
  },
  playBackModal: (val: string, titleName?: string) => {
    if ((window as any).raw) {
      if (getLocalStorage(AdminConfig.strWinId)) {
        (window as any).raw.reloadWindow(
          {
            url: `${window.location.origin}/competition/live?VideoUrl=${val}&titleName=${titleName}`,
            winId: getLocalStorage(AdminConfig.strWinId)
          },
          (e: any) => {
            if (e.status === 'reject') {
              playBackModalProps(val, titleName);
            }
          }
        );
        return;
      }
      playBackModalProps(val, titleName);
    }
  },
  openVoiceModal: () => {
    if (ignoreLive()) {
      return;
    }
    if ((window as any).raw) {
      if (getLocalStorage('VOICE_CLOSE_STATE')) {
        if (getLocalStorage(AdminConfig.voiceWinId)) {
          // 如果是小球状态
          const ballInfo: any = LocalStore.getValue('VOICE_HEADTOP_STATE');
          if (ballInfo && ballInfo.isBall) {
            LocalStore.setValue('VOICE_IS_BALL_STATE', Date.now());
          }
          if ((window as any).raw.controlWindow) {
            (window as any).raw.controlWindow({
              operation: 'show',
              winId: getLocalStorage(AdminConfig.voiceWinId)
            });
            return;
          }
        }
      }
      const time = getLocalStorage('VOICE_CLOSE_STATE_TIME') ? Number(getLocalStorage('VOICE_CLOSE_STATE_TIME')) : '';
      if (!time || (time && Date.now() > time)) {
        setLocalStorage('VOICE_CLOSE_STATE_TIME', (Date.now() + 3000).toString());
        ProjFn.toCreateVoiceModal();
      }
    }
  },
  openLiveNoticesModal: () => {
    if ((window as any).raw) {
      if (getLocalStorage('LIVENOTICE_CLOSE_STATE')) {
        if (getLocalStorage(AdminConfig.liveNoticeWinId)) {
          if ((window as any).raw.controlWindow) {
            (window as any).raw.controlWindow({
              operation: 'show',
              winId: getLocalStorage(AdminConfig.liveNoticeWinId)
            });
            window.localStorage.setItem('isThisInLocalStorage', 'true');
            window.dispatchEvent(new Event('storage'));
            localStorage.setItem('liveNoticeRenew', moment().valueOf() + '');
            return;
          }
        }
      }
      const time = getLocalStorage('VOICE_CLOSE_STATE_TIME') ? Number(getLocalStorage('VOICE_CLOSE_STATE_TIME')) : '';
      if (!time || (time && Date.now() > time)) {
        setLocalStorage('VOICE_CLOSE_STATE_TIME', (Date.now() + 3000).toString());
        ProjFn.toLiveNoticeVoiceModal();
      }
    }
  },
  openChatMsgNoticeModal: () => {
    if ((window as any).raw) {
      if (getLocalStorage('CHATNOTICE_CLOSE_STATE')) {
        if (getLocalStorage(AdminConfig.chatMsgNoticeWinId)) {
          if ((window as any).raw.controlWindow) {
            (window as any).raw.controlWindow({
              operation: 'show',
              winId: getLocalStorage(AdminConfig.chatMsgNoticeWinId)
            });
            window.localStorage.setItem('isThisInLocalStorage', 'true');
            window.dispatchEvent(new Event('storage'));
            localStorage.setItem('chatMsgNoticeRenew', moment().valueOf() + '');
            return;
          }
        }
      }
      const time = getLocalStorage('CHATN_CLOSE_STATE_TIME') ? Number(getLocalStorage('CHATN_CLOSE_STATE_TIME')) : '';
      if (!time || (time && Date.now() > time)) {
        setLocalStorage('CHATN_CLOSE_STATE_TIME', (Date.now() + 3000).toString());
        ProjFn.toChatMsgNoticeModal();
      }
    }
  },
  openLiveRaffleModal: () => {
    if ((window as any).raw) {
      if (getLocalStorage('LIVERAFFLE_CLOSE_STATE')) {
        if (getLocalStorage(AdminConfig.liveRaffleWinId)) {
          if ((window as any).raw.controlWindow) {
            (window as any).raw.controlWindow({
              operation: 'show',
              winId: getLocalStorage(AdminConfig.liveRaffleWinId)
            });
            // window.localStorage.setItem('isThisInLocalStorage', 'true');
            // window.dispatchEvent(new Event('storage'));
            // localStorage.setItem('liveRaffleRenew', moment().valueOf() + '');
            return;
          }
        }
      }
      const time = getLocalStorage('LIVERAFFLE_CLOSE_STATE_TIME')
        ? Number(getLocalStorage('LIVERAFFLE_CLOSE_STATE_TIME'))
        : '';
      if (!time || (time && Date.now() > time)) {
        setLocalStorage('LIVERAFFLE_CLOSE_STATE_TIME', (Date.now() + 3000).toString());
        ProjFn.toliveRaffleModal();
      }
    }
  },
  toCreateVoiceModal: () => {
    Object.values(localKeyInfo).forEach((item: string) => {
      removeLocalStorage(item);
    });
    (window as any).raw.createWindow(
      {
        url: `${window.location.origin}/voiceHome`,
        width: 1440,
        height: 900,
        minW: 1440,
        minH: 900,
        transparent: true,
        unsafe: true
      },
      (e: any) => {
        if (e.status === 'resolve') {
          setLocalStorage(AdminConfig.voiceWinId, e.data.winId);
        }
      }
    );
  },
  toLiveNoticeVoiceModal: () => {
    Object.values(localKeyInfo).forEach((item: string) => {
      removeLocalStorage(item);
    });
    (window as any).raw.createWindow(
      {
        url: `${window.location.origin}/liveNotice`,
        width: 320,
        height: 205,
        minW: 320,
        minH: 205,
        transparent: true
      },
      (e: any) => {
        if (e.status === 'resolve') {
          setLocalStorage(AdminConfig.liveNoticeWinId, e.data.winId);
        }
      }
    );
  },
  toChatMsgNoticeModal: () => {
    Object.values(localKeyInfo).forEach((item: string) => {
      removeLocalStorage(item);
    });
    (window as any).raw.createWindow(
      {
        url: `${window.location.origin}/chatMsgNotice`,
        width: 348,
        height: 106,
        minW: 348,
        minH: 106,
        transparent: true
      },
      (e: any) => {
        if (e.status === 'resolve') {
          setLocalStorage(AdminConfig.chatMsgNoticeWinId, e.data.winId);
        }
      }
    );
  },
  toGameStatusNoticeModal: (processName?: string) => {
    ProjFn.sdkBoxCollect('pc_gamestartwrong', { game_type: processName2Type[processName || ''] });
    Object.values(localKeyInfo).forEach((item: string) => {
      removeLocalStorage(item);
    });
    (window as any).raw.createWindow(
      {
        url: `${window.location.origin}/gameStatusNotice`,
        width: 314,
        height: 176,
        minW: 314,
        minH: 176,
        transparent: true
      },
      (e: any) => {
        if (e.status === 'resolve') {
          setLocalStorage(AdminConfig.GAME_STATUS_NOTICE_WINID, e.data.winId);
        }
      }
    );
  },
  toliveRaffleModal: () => {
    const flag = localStorage.getItem('liveRaffle-initial') === '1' ? false : true;
    const w = flag ? 680 : 1060;
    const y = flag ? 748 : 690;
    (window as any).raw.createWindow(
      {
        url: `${window.location.origin}/liveRaffleHome`,
        width: w,
        height: y,
        minW: w,
        minH: y,
        transparent: true
      },
      (e: any) => {
        if (e.status === 'resolve') {
          setLocalStorage(AdminConfig.liveRaffleWinId, e.data.winId);
        }
      }
    );
  },
  openServiceModal: (data: string, str?: string) => {
    if ((window as any).raw) {
      // if (getLocalStorage('SERVICE_CLOSE_STATE')) {
      if (getLocalStorage(AdminConfig.serviceWinId)) {
        const availWidth = (window as any).screen.availWidth;
        const availHeight = (window as any).screen.availHeight;
        const posX = (availWidth - 600) / 2;
        const posY = (availHeight - 630) / 2;
        if ((window as any).raw.controlWindow) {
          LocalStore.setValue('SERVICE_CLOSE_STATE', '');
          if (getLocalStorage('sessionUrl') === str) {
            (window as any).raw.controlWindow({
              operation: 'show',
              winId: getLocalStorage(AdminConfig.serviceWinId)
            });
          } else {
            (window as any).raw.controlWindow({
              operation: 'rediretion',
              url: `${window.location.origin}/ViewWhisper${data}`,
              winId: getLocalStorage(AdminConfig.serviceWinId)
            });
          }
          (window as any).raw.controlWindow({
            operation: 'alwayTopDisable',
            winId: getLocalStorage(AdminConfig.serviceWinId)
          });
        }
        if ((window as any).raw.setWindowPosition) {
          (window as any).raw.setWindowPosition({
            x: posX,
            y: posY,
            winId: getLocalStorage(AdminConfig.serviceWinId)
          });
        }
        if ((window as any).raw.setWindowSize) {
          (window as any).raw.setWindowSize({
            width: 600,
            height: 630,
            winId: getLocalStorage(AdminConfig.serviceWinId)
          });
          return;
        }
        /* if ((window as any).raw.controlWindow) {
            (window as any).raw.controlWindow({
              operation: 'show',
              winId: getLocalStorage(AdminConfig.serviceWinId)
            });
            return;
          } */
      }
      // }
      ProjFn.toCreateServiceModal(data);
    }
  },
  // 开启区服客服子窗口
  toCreateServiceModal: (data: string) => {
    (window as any).raw.createWindow(
      {
        url: `${window.location.origin}/ViewWhisper${data}`,
        width: 600,
        height: 630,
        minW: 600,
        minH: 630,
        transparent: true,
        resizeable: 'disabled'
      },
      (e: any) => {
        if (e.status === 'resolve') {
          setLocalStorage(AdminConfig.serviceWinId, e.data.winId);
        }
      }
    );
  },
  openServiceMutiModal: (data: string) => {
    const serviceMap = JSON.parse(getLocalStorage('serviceMuti') ? getLocalStorage('serviceMuti') : '{}');
    if (serviceMap && serviceMap[data]) {
      const availWidth = (window as any).screen.availWidth;
      const availHeight = (window as any).screen.availHeight;
      const posX = (availWidth - 600) / 2;
      const posY = (availHeight - 630) / 2;
      if ((window as any).raw.controlWindow) {
        (window as any).raw.controlWindow({
          operation: 'rediretion',
          url: `${window.location.origin}/ViewWhisper${data}`,
          winId: serviceMap[data]
        });
        (window as any).raw.controlWindow({
          operation: 'alwayTopDisable',
          winId: serviceMap[data]
        });
      }
      if ((window as any).raw.setWindowPosition) {
        (window as any).raw.setWindowPosition({
          x: posX,
          y: posY,
          winId: serviceMap[data]
        });
      }
      if ((window as any).raw.setWindowSize) {
        (window as any).raw.setWindowSize({
          width: 600,
          height: 630,
          winId: serviceMap[data]
        });
        return;
      }
    } else {
      (window as any).raw.createWindow(
        {
          url: `${window.location.origin}/ViewWhisper${data}`,
          width: 600,
          height: 630,
          minW: 600,
          minH: 630,
          transparent: true,
          resizeable: 'disabled'
        },
        (e: any) => {
          if (e.status === 'resolve') {
            serviceMap[data] = e.data.winId;
            setLocalStorage('serviceMuti', JSON.stringify(serviceMap));
          }
        }
      );
    }
  },
  openBaseInfoModal: () => {
    if ((window as any).raw) {
      if (getLocalStorage('BASE_INFO_STATE')) {
        if (getLocalStorage(AdminConfig.baseInfoWinId)) {
          if ((window as any).raw.controlWindow) {
            (window as any).raw.controlWindow({
              operation: 'show',
              winId: getLocalStorage(AdminConfig.baseInfoWinId)
            });
            return;
          }
        }
      }
      const time = getLocalStorage('BASE_INFO_STATE_TIME') ? Number(getLocalStorage('BASE_INFO_STATE_TIME')) : '';
      if (!time || (time && Date.now() > time)) {
        setLocalStorage('BASE_INFO_STATE_TIME', (Date.now() + 3000).toString());
        ProjFn.toCreateBaseInfoModal();
      }
    }
  },
  toCreateBaseInfoModal: () => {
    (window as any).raw.createWindow(
      {
        url: `${window.location.origin}/baseInfoHome`,
        width: 1000,
        height: 711,
        minW: 1000,
        minH: 711
      },
      (e: any) => {
        if (e.status === 'resolve') {
          setLocalStorage(AdminConfig.baseInfoWinId, e.data.winId);
        }
      }
    );
  },
  // 保留两位小数
  glodByHundred: (num: number) => {
    const maxGlod = parseFloat((num * 100).toFixed(2));
    return -maxGlod;
  },
  iamalive: () => {
    setTimeout(() => {
      if ((window as any).raw && (window as any).raw.alive) {
        (window as any).raw.alive({}, (e: any) => {
          console.log(e);
        });
        (window as any).raw.alive({}, (e: any) => {
          console.log(e);
        });
      }
      sdk.Burying({
        uid: '',
        eventname: 'device_login',
        eventtype: 'track'
      });
      if (sessionStorage.getItem('PROXYSTATUS')) {
        sdk.Burying({
          uid: '',
          eventname: 'dailifangwen',
          eventtype: 'track'
        });
        loginCollect(1660);
      } else {
        if (window.location.hostname === 'newpc.996box.com') {
          sdk.Burying({
            uid: '',
            eventname: 'zhuyuming',
            eventtype: 'track'
          });
          loginCollect(1658);
        } else {
          sdk.Burying({
            uid: '',
            eventname: 'beiyuming',
            eventtype: 'track',
            properities: {
              domain: window.location.hostname
            }
          });
          loginCollect(1659);
        }
      }
    }, 1000);
  },
  openExternalBrower: (url: string) => {
    if ((window as any).raw && (window as any).raw.openExternalBrower) {
      (window as any).raw.openExternalBrower({ url }, (e: any) => {
        console.log(e);
      });
    }
  },
  logoutClearInfo: () => {
    setTimeout(() => {
      store.dispatch(
        setBaseTipInfo({
          visible: false,
          title: '系统提示',
          message: '',
          saveText: ''
        })
      );
    }, 800);
  },
  cacheChange: (res: any) => {
    if (res.code && res.code === 200 && res.data) {
      return true;
    }
    return false;
  },
  electronMemberModal: (URL: string, WINID: string) => {
    (window as any).raw.createWindow(
      {
        url: URL,
        width: 1000,
        height: 745,
        minW: 1000,
        minH: 745
      },
      (e: any) => {
        if (e.status === 'resolve') {
          setLocalStorage(WINID, e.data.winId);
        }
      }
    );
  },
  playMainModal: (val: string) => {
    if ((window as any).raw) {
      if (getLocalStorage(val)) {
        (window as any).raw.refrushOtherWindow({
          // url: `${window.location.origin}${url}`,
          winId: getLocalStorage(val)
        });
      }
    }
  },
  getWebsocketUrl: (url: string, params: any) => {
    const appv = localStorage.getItem('appv')?.replace(/&.+/, '') || '';
    const status = ProjFn.compareVersion(appv, '5.0.1');
    const hasBoxAuth = status >= 0;
    const useEncode = typeof window !== 'undefined' && hasBoxAuth;
    let str = '';
    for (const key in params) {
      if (useEncode) {
        const value = params[key];
        str += `${key}=${encodeURIComponent(value !== undefined && value !== null ? String(value) : '')}&`;
      } else {
        str += `${key}=${params[key]}&`;
      }
    }
    str = str.substr(0, str.length - 1);
    url = url + '?' + str;
    return url;
  },
  getStrNum: (str: string, num: number) => {
    if (str.length > num) {
      str = str.substring(0, num) + '...';
    }
    return str;
  },
  postCollect: async (secondEvent: any, postId: any, stayTime: any) => {
    const appv: any = localStorage.getItem('appv');
    const str = localStorage.getItem('BASE_TRUMPET_INFO');
    const data = str ? JSON.parse(str) : {};
    const userId = data && data.uid ? data.uid : 0;
    const date: any = new Date();
    const dateNumFun: any = (num: number) => (num < 10 ? `0${num}` : num);
    const [Y, M, D, h, m, s] = [
      date.getFullYear(),
      dateNumFun(date.getMonth() + 1),
      dateNumFun(date.getDate()),
      dateNumFun(date.getHours()),
      dateNumFun(date.getMinutes()),
      dateNumFun(date.getSeconds())
    ];
    const time = `${Y}-${M}-${D} ${h}:${m}:${s}`;
    const obj: any = {
      created_at: time,
      device: 'pc',
      appv: appv ? appv : '1.0.0',
      series: secondEvent ? secondEvent : '',
      user_id: userId,
      post_id: postId ? postId : 0,
      stay_time: stayTime ? stayTime : 0
    };
    const resObj = await postCollect(obj);
    return resObj;
  },
  // sdk埋点(996魔方)
  sdkBoxCollect: (ch: string, key?: any) => {
    const str = localStorage.getItem('BASE_TRUMPET_INFO');
    const obj = str ? JSON.parse(str) : {};
    const uid = obj && obj.uid ? obj.uid : 0;
    const data: any = {
      eventname: ch,
      eventtype: 'track',
      uid,
      properities: { user_id: uid, ...key }
    };
    sdk.Burying(data);
  },
  // 打开砍砍活动页
  openActiveKanKan: (url: string, history?: any, cutLegendEntryType?: string, target?: string, cb?: Function) => {
    const { userinfo } = store.getState().user;
    // 砍砍传奇 - 实名认证
    (Window as any).toRealName = function () {
      // 实名弹窗
      if (userinfo.auth_status === 0) {
        store.dispatch(
          setRealnameInfo({
            visible: true
          })
        );
        return false;
      }
    };
    // 砍砍传奇 - 跳转直播tab
    (Window as any).toLiveTab = function (res: string) {
      // pc 默认只会在直播间内打开活动页面，故去完成只关闭活动窗口
      return StorageFn.electronCloseActivity();
      // if (history.location.pathname === '/voiceHome' || history.location.pathname === '/newLive/studio') {
      //   StorageFn.electronCloseActivity();
      // }
      // try {
      //   const data = JSON.parse(res);
      //   // 完成任务弹窗
      //   const path = '/newLive/allLive';
      //   const { categoryList } = store.getState().liveHead;
      //   let currentTab, index;
      //   for (let i = 0, len = categoryList.length; i < len; i += 1) {
      //     if (data.liveTabId === Number(categoryList[i].id)) {
      //       currentTab = categoryList[i];
      //       index = i;
      //       break;
      //     }
      //   }
      //   if (currentTab) {
      //     history.push(path, {
      //       limit: currentTab.id,
      //       title: currentTab.name,
      //       tag_id: currentTab.tags[0] ? currentTab.tags[0].tag_id : 0,
      //       index
      //     });
      //   }
      // } catch (e) {
      //   console.warn(e);
      //   console.warn('get params from h5 fail toLiveTab');
      // }
    };
    // 砍砍传奇 - 刷新元宝
    (Window as any).toRefreshGold = function (res: string) {
      // h5砍砍传奇消耗元宝后，刷新直播间的用户元宝数
      try {
        const data = JSON.parse(res);
        // 1直播列表 2游戏直播间 3娱乐直播间 4语音房
        if (cutLegendEntryType === '4') {
          const BC = new BroadcastChannel('voiceBoardcast');
          BC.postMessage({
            time: Date.now(),
            balance: Number(data.remainGold) ? Number(data.remainGold) : 0
          });
        } else {
          const BC = new BroadcastChannel('liveRoom:toolbarGold');
          BC.postMessage({
            time: Date.now(),
            balance: Number(data.remainGold) ? Number(data.remainGold) : 0
          });
        }
      } catch (e) {
        console.warn(e);
        console.warn('get params from h5 fail toRefreshGold');
      }
    };
    // 砍砍传奇 - 元宝充值
    (Window as any).toGoldRecharge = function (res: string) {
      try {
        const data = JSON.parse(res);
        // 元宝充值
        if (data.target === 'main') {
          const BC = new BroadcastChannel('gameBoardcast');
          // BC.postMessage(data.priceId);
          // 由于窗口同时打开，故不需要
          BC.postMessage(Date.now());
        } else {
          const BC = new BroadcastChannel('voiceBoardcast');
          BC.postMessage(Date.now());
        }
      } catch (e) {
        console.warn(e);
        console.warn('get params from h5 fail toGoldRecharge');
      }
    };
    // 活动模板 - 跳转交易行
    (Window as any).toTransaction = function (res: string) {
      try {
        const data = JSON.parse(res);
        if (data.toTransaction) {
          localStorage.setItem('NAV_TABBTN_ID', '1');
          // 设置首页交易行
          const BC = new BroadcastChannel('gameTypeBoardcast:transaction');
          BC.postMessage(Date.now());
        }
      } catch (e) {
        console.warn(e);
        console.warn('get params from h5 fail toTransaction');
      }
    };
    // 活动模板 - 跳转具体直播间
    (Window as any).toLiveRoom = function (res: string) {
      const data = JSON.parse(res);
      if (data.liveId) {
        const params: any = liveFn.toStudioRoom({
          pathname: '/newLive/home',
          roomId: Number(data.liveId)
        });
        history.push(params?.path || '', params?.state);
      }
    };
    // 活动模板 - 前往充值券页面
    (Window as any).toRecharge = function (res: string) {
      const data = JSON.parse(res);
      if (data.toRecharge) history.push('/user/personal/wallet/voucher');
    };
    // 活动模板 - 前往金币提现页面
    (Window as any).toWithdraw = function (res: string) {
      const data = JSON.parse(res);
      if (data.toWithdraw) {
        if (userinfo.auth_status !== 1) {
          history.push('/user/personal/certification');
          return false;
        }
        history.push('/user/personal/wallet');
      }
    };
    // 活动模板 - 对应的游戏详情页
    (Window as any).toGameDetail = function (res: string) {
      const data = JSON.parse(res);
      if (data.toGameDetail) {
        history.push('/gameDetail', { id: Number(data.toGameDetail), type: 1 });
      }
    };
    // 活动模板 - 前往直播页面
    (Window as any).toLive = function (res: string) {
      const data = JSON.parse(res);
      if (data.toLive) history.push('/newLive/home');
    };
    // 活动模板 - 前往会员页面
    (Window as any).toMember = function (res: string) {
      const data = JSON.parse(res);
      if (data.toMember) history.push('/home/member');
    };
    // 活动模板 - 前往任务页面
    (Window as any).toTask = function (res: string) {
      const data = JSON.parse(res);
      if (data.toTask) history.push('/home/task');
    };
    // 活动模板 - 前往区服充值页
    (Window as any).toGameRecharge = async (res: string) => {
      const data = JSON.parse(res);
      if (data.toGameRecharge) history.push('/gameRecherge');
    };
    // 活动模板 - 前往社区页面
    (Window as any).toCommunity = function (res: string) {
      const data = JSON.parse(res);
      if (data.toCommunity) history.push('/home/community');
    };
    // 活动模板 - 前往抽奖中心
    (Window as any).toRaffleCenter = function (res: string) {
      const data = JSON.parse(res);
      if (data.toRaffleCenter) history.push('/home/raffle');
    };
    // 活动模板 - 前往收货地址
    (Window as any).toAddressManage = function (res: string) {
      const data = JSON.parse(res);
      if (data.toAddressManage) history.push('/user/personal/address');
    };
    // // 活动模板 - 前往云手机页面
    // (Window as any).toCloudPhone = function (res: string) {
    //   const data = JSON.parse(res);
    //   if (data.toCloudPhone) message.info('积分已到账，请及时在移动端设备进行使用，过期无效');
    // };
    // // 活动模板 - 前往积分商城
    // (Window as any).toShop = function (res: string) {
    //   const data = JSON.parse(res);
    //   if (data.toShop) message.info('云手机已到账，请及时在移动端设备进行使用，过期无效');
    // };
    // 活动模板 -  在玩 前往首页
    (Window as any).toPlay = function (res: string) {
      const data = JSON.parse(res);
      if (data.toPlay) history.push('/home/homePage');
    };
    StorageFn.electronCloseActivity();
    setTimeout(() => {
      StorageFn.electronOpenActivity(url, cutLegendEntryType, target).then(res => {
        if (res === 'hasWindow' && cb) {
          cb('您已打开活动页面');
        }
      });
    }, 500);
  },
  shopCartConf: (game_id?: string | number, sub_uid?: string | number, collect?: string) => {
    apiShopCartConf({ game_id, sub_uid }).then(({ data }: { data: ShopCartConfProps }) => {
      store.dispatch(updateShopCartConfs(data));
      if (collect) {
        const params = {
          cart_goods_num_after_add: data.shop_cart_count,
          cart_items_num_after_add: data.user_total_cart_count
        };
        sdkBoxCollect(collect, params);
      }
    });
  },
  shopCartUid: (data: GetListProps[], bol?: boolean) => {
    for (const element of data) {
      if (element.check && (data[0].uid !== element.uid || bol)) {
        return element.uid;
      }
    }
    return '';
  },
  isVersionChange: (vesion: number) => {
    const strVersion: any = localStorage.getItem('appv')?.replace(/&.+/, '');
    let numVersion = strVersion.replace(/[^0-9]/g, '');
    const mainVersion = numVersion.slice(0, 3);
    const isVersion = Number(mainVersion) >= vesion;
    return isVersion;
  }
};
export default ProjFn;

(Window as any).gameStatusWarn = ProjFn.toGameStatusNoticeModal;
